import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, of } from 'rxjs';
import { filter, take, switchMap, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment'
import { TupssService } from './tupss.service';
import { AuthService } from '@auth0/auth0-angular';

@Injectable({
  providedIn: 'root'
})
export class TupssGuard  {
  constructor(
    private router: Router,
    private jwtHelper: JwtHelperService,
    private tupssService: TupssService,
    private auth: AuthService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let idTokenString = route.fragment ? route.fragment : this.tupssService.getTfcpTokenString(); //Gets token from URL or from sessionStorage
    let hasToken: boolean = !!idTokenString;  //Boolean variable to tell if we have token or not from TFCP
    let token = hasToken && idTokenString ? idTokenString.match(/id_token=([\w_.\-]+)/i) : null; //Regex to extract the actual token from the URL fragment.
    hasToken = token != null && token.length > 1 && token[1] != null;
    if (hasToken && token && !this.jwtHelper.isTokenExpired(token[1])) {
      sessionStorage.setItem('URLFragment', idTokenString);
      let email = this.jwtHelper.decodeToken(token[1]).businessEmail;
      return this.checkAuth0Token(email);
    } else {
      if (state.url.startsWith('/tupss')) { //Tccp users won't need an idToken
        if (sessionStorage.getItem('userDetails') || this.tupssService.userDetails) {
          return true;
        } else {
          this.router.navigate(['/unauthorized'], { skipLocationChange: true, replaceUrl: true });
          return false;
        }
      } else if (state.url.startsWith('/tfcp')) { //For TFCP routes, if token from TFCP login is not present, go here.
        sessionStorage.clear();
        window.location.href = environment.tupss.signin;
        return of(false);
      }
    }
  }

  checkAuth0Token(email: string) {
    return this.auth.isLoading$.pipe(
      filter(loading => !loading),
      take(1),
      switchMap(() => this.auth.idTokenClaims$),
      take(1),
      map(response => {
        if (!response) {
          if (environment.baseUrl.urlType != 'prod' && environment.baseUrl.urlType != 'uat') {
            this.initiatePasswordlessAuthTESTINGENVIRONMENTS();
          } else {
            this.initiatePasswordlessAuth(email);
          }
          return false;
        }
        return !!(response.__raw && response.email);
      })
    );
  }

  initiatePasswordlessAuthTESTINGENVIRONMENTS() {
    this.auth.loginWithRedirect({
      authorizationParams: {
        connection: 'email',
        redirect_uri: `${environment.baseUrl.web}callback`,
        'ext-connect': 'email', //additional param to indicate template to hide "sign up" and "login" text
        'ext-style': 'tupss',
        organization: environment.auth0.tupssOrganization,
      },
      appState: { target: '/tfcp' }
    });
  }

  initiatePasswordlessAuth(email: string) {
    this.auth.loginWithRedirect({
      authorizationParams: {
        connection: 'email',
        login_hint: email,
        redirect_uri: `${environment.baseUrl.web}callback`,
        'ext-connect': 'email', //additional param to indicate template to hide "sign up" and "login" text
        'ext-type': 'hint',
        'ext-style': 'tupss',
        organization: environment.auth0.tupssOrganization,
      },
      appState: { target: '/tfcp' }
    });
  }
}
